import GreenCheckIcon from '../../assets/images/icons/GreenCheckIcon';
import RedCrossIcon from '../../assets/images/icons/RedCrossIcon';
import GreyCircleIcon from '../../assets/images/icons/GreyCircleIcon';
import {
  ICallHistory,
  ICallHistoryProps,
  CALL_STATUSES,
  ICallStatusProps,
  ICallStatusListProps
} from './interfaces';
import styles from './CallHistory.module.scss';
import { formatDate } from 'src/utils/commonUtils';

export const NO_OF_RECORDS = 5;
const callHistoryContainerArray = [...Array(NO_OF_RECORDS)];

const CallStatus = (props: ICallStatusProps) => {
  const { receiverStatus, tooltip } = props;
  return (
    <span title={tooltip}>
      {' '}
      {receiverStatus === CALL_STATUSES.ANSWER ? <GreenCheckIcon /> : <RedCrossIcon />}
    </span>
  );
};

const CallStatusList = ({ list, showTooltip }: ICallStatusListProps) => (
  <>
    {callHistoryContainerArray?.map((el, index) => {
      const { receiverStatus, interactionTimestamp } = (list?.[index] || {}) as ICallHistory;

      if (!receiverStatus && !interactionTimestamp)
        return <GreyCircleIcon key={`no-call-${index}`} />;

      return (
        <CallStatus
          key={`call-checked-${interactionTimestamp}`}
          receiverStatus={receiverStatus}
          interactionTimestamp={interactionTimestamp}
          tooltip={
            showTooltip
              ? `Called on: ${formatDate(interactionTimestamp, {
                  year: 'numeric'
                })}`
              : ''
          }
        />
      );
    })}
  </>
);

const CallHistory = ({ list = [], showTooltip }: ICallHistoryProps) => {
  return (
    <div className={styles.callHistory}>
      <CallStatusList list={list} showTooltip={showTooltip} />
    </div>
  );
};

export default CallHistory;
